import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import styles from "./Disconnect.module.scss";
import { ConnectionHubFromScreen, IIntegrationPartner, IpNames, JobType, rpaTypes, UserRole } from "../../../interfaces/interfaces";
import { RestS } from "../../../rest/rest-service";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { IpRestS } from "../../../rest/ipRest-service";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import {
  deleteConnections,
  fetchCurrentConnections,
} from "../../../redux/connections/connSlice";
import { AiFillInfoCircle } from "react-icons/ai";
import {
  BsFillCheckCircleFill,
  BsExclamationTriangleFill,
} from "react-icons/bs";
import Integrations from "../../../components/common/Integrations/Integration";
import { getLocalUser } from "../../../components/functions/utilities";
import { VscUnlock } from "react-icons/vsc";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri'
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { fetchAccessTokens } from "../../../redux/accessTokens/accessTokens";

type Props = {
  ip: IIntegrationPartner;
  accounts: any;
  setAccounts: Function;
  setStep: Function;
  step: number;
  disonnectRef: any;
  onDisconnectRefresh?: () => void;
  setIp?: any;
  expiredAccounts: any;
  fromScreen: ConnectionHubFromScreen;
  refreshExpiredAccounts?: () => void;
};

const initialDeleteItem = { accessTokenId: null, isConnected: false };

export const showDisconnectionSplit = new Set([ConnectionHubFromScreen?.underwriting]);

const DisconnectScreen = ({
  ip,
  accounts,
  setAccounts,
  setStep,
  step,
  disonnectRef,
  onDisconnectRefresh = () => { },
  setIp,
  expiredAccounts = [],
  fromScreen = null,
  refreshExpiredAccounts = () => { }
}: Props) => {
  const dispatch = useAppDispatch();
  const [selectedId, setSelectedId] = useState(0);
  const [selectedAccount, setSelectedAccount] = useState<any>({});
  const [expiredIpAccounts, setExpiredIpAccounts] = useState([]);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
  const [deleteItem, setDeleteItem] = useState(initialDeleteItem);
  const isRPA = rpaTypes.includes(ip?.authMethod);

  const currentUser = getLocalUser();
  const isAgency = currentUser?.role === UserRole.Agency;
  const { currentClient } = useAppSelector((state) => state.agencyConfig);

  const disConnectAcc = async () => {
    console.log('Disconnecting the account having isRPA', isRPA, ip)
    if (isRPA) {
      // Disconnect all tokens which has same customer_id as selected account.
      const deletedAccounts = accounts.filter(acc => acc.customer_id == selectedAccount.customer_id)
      for (const acc of deletedAccounts) {
        await IpRestS.uninstallUser(ip?._id, ip?.companyName, acc.id)
          .then((res) => {
            dispatch(fetchCurrentConnections({
              companyId: isAgency ? currentClient?.id : null,
            }));
            // RestS.regenerateInsights();
          })
          .catch((err) => {
            dispatch(fetchCurrentConnections({
              companyId: isAgency ? currentClient?.id : null,
            }));
          });
      }
      setAccounts((prev) => {
        const temp = prev.filter((acc) => acc.customer_id != selectedAccount.customer_id);
        const arrLength = temp.filter((acc) => acc.integrationPartner == ip._id);
        if (arrLength < 1) {
          dispatch(deleteConnections(ip?._id));
        }
        console.log(temp);
        return temp;
      });
      RestS.refreshNow({
        ip: ip,
        jobType: JobType.refreshNow,
        agencyClientId: isAgency ? currentClient?.id : null,
      });
      onDisconnectRefresh();
      refreshExpiredAccounts();
    } else {
      setAccounts((prev) => {
        const temp = prev.filter((acc) => acc.id != selectedId);
        const arrLength = temp.filter((acc) => acc.integrationPartner == ip._id);
        if (arrLength < 1) {
          dispatch(deleteConnections(ip?._id));
        }
        console.log(temp);
        return temp;
      });
      IpRestS.uninstallUser(ip?._id, ip?.companyName, selectedId)
        .then((res) => {
          dispatch(fetchCurrentConnections({
            companyId: isAgency ? currentClient?.id : null,
          }));
          RestS.refreshNow({
            ip: ip,
            jobType: JobType.refreshNow,
            agencyClientId: isAgency ? currentClient?.id : null,
          });
          onDisconnectRefresh();
          // RestS.regenerateInsights();
        })
        .catch((err) => {
          dispatch(fetchCurrentConnections({
            companyId: isAgency ? currentClient?.id : null,
          }));
        });
    }
  };

  const getName = (selectedAccount) => {
    const name = selectedAccount.storeName
      ? selectedAccount.storeName
      : selectedAccount.client_name
        ? selectedAccount.client_name
        : selectedAccount.client_id
          ? selectedAccount.client_id
          : selectedAccount.customer_name
            ? selectedAccount.customer_name
            : selectedAccount.customer_id;

    return name;
  };

  useImperativeHandle(disonnectRef, () => ({
    disConnectAcc,
  }));

  useEffect(() => {
    console.log('expiredAccounts', expiredAccounts)
    if ((
      // !ip?.isSalesChannel && 
      showDisconnectionSplit?.has(fromScreen)) || isRPA) {
      const ipAccounts = expiredAccounts?.reduce((prev, curVal) => {
        if (curVal?.integrationPartner == ip._id) {
          prev.push({
            ...curVal,
            expired: true
          })
        }
        return prev;
      }, [])
      setExpiredIpAccounts(ipAccounts)
    } else {
      const ipAccounts = expiredAccounts?.map((acc) => {
        // if (acc.integrationPartner == ip._id && ip.companyName == IpNames?.flipkartSeller) {
        //   return {
        //     ...acc,
        //     expired: true
        //   }
        // } else {
        return null
        // }
      }).filter(acc => acc != null)
      setExpiredIpAccounts(ipAccounts)
    }
  }, [expiredAccounts, accounts])

  const [connectedAccounts, setConnectedAccounts] = useState([])
  const [connectedAccountsRPA, setConnectedAccountsRPA] = useState([])
  const [disconnectedAccounts, setDisconnectedAccounts] = useState([])
  const [disconnectedAccountsRPA, setDisconnectedAccountsRPA] = useState([])
  const [showExpiredSplit, setShowExpiredSplit] = useState(false)

  useEffect(() => {
    const showExpiredSplit = showDisconnectionSplit?.has(fromScreen);
    // && !ip?.isSalesChannel
    const connectedAccounts = accounts.filter((data) => data.integrationPartner == ip._id) // showExpiredSplit ? accounts.filter((data) => data.integrationPartner == ip._id) : accounts.concat(expiredIpAccounts).filter((data) => data.integrationPartner == ip._id) // only for sales channel and specifically flipkart it will concat expired account because there is different flow for it.
    const connectedAccountsRPA = connectedAccounts.reduce((accumulator, currValue) => {
      if (currValue?.customer_id in accumulator) {
        accumulator[currValue?.customer_id].push(currValue)
      } else {
        accumulator[currValue?.customer_id] = [currValue]
      }
      return accumulator
    }, {})
    setShowExpiredSplit(showExpiredSplit)
    setConnectedAccounts(connectedAccounts)
    setConnectedAccountsRPA(connectedAccountsRPA)
  }, [accounts, expiredIpAccounts])

  useEffect(() => {
    const showExpiredSplit = showDisconnectionSplit?.has(fromScreen)
    // !ip?.isSalesChannel &&
    const disconnectedAccounts = showExpiredSplit || isRPA ? expiredIpAccounts : [];
    // const disconnectedAccountsRPA = disconnectedAccounts.reduce((accumulator, currValue) => {
    //   if (currValue?.customer_id in accumulator) {
    //     accumulator[currValue?.customer_id].push(currValue)
    //   } else {
    //     accumulator[currValue?.customer_id] = [currValue]
    //   }
    //   return accumulator
    // }, {})
    setShowExpiredSplit(showExpiredSplit)
    setDisconnectedAccounts(disconnectedAccounts)
    // setDisconnectedAccountsRPA(disconnectedAccountsRPA)
  }, [expiredIpAccounts])

  const deleteAccount = async (accessTokenId: number, isConnected: boolean) => {
    try {
      if (!isConnected) {
        setDeleteBtnLoading(true);
        const bodyData = {
          ipName: ip?.companyName,
          accessTokenId,

        }
        const data: any = await RestS.deleteAccountFromFs(bodyData);
        refreshExpiredAccounts();
      }
    } catch (error) {
      console.log('Error deleting account', error)
    } finally {
      setDeleteBtnLoading(false);
      setShowDeleteConfirmation(false);
    }
  }


  return (
    <>
      {step == 5 ? (
        <div className={styles.rootContainer}>
          {(isRPA && Object.keys(connectedAccountsRPA).length) || connectedAccounts?.length ?
            <div className={styles.accountSection}>
              {
                isRPA ?
                  Object.values(connectedAccountsRPA)?.length ? <div className={styles.accountHeader}>
                    CONNECTED ACCOUNTS ({Object.values(connectedAccountsRPA)?.length})
                  </div> : null
                  :
                  connectedAccounts?.length ? <div className={styles.accountHeader}>
                    CONNECTED ACCOUNTS ({connectedAccounts?.length})
                  </div> : null
              }
              <div className={styles.acc}>
                {
                  isRPA ?
                    Object.keys(connectedAccountsRPA).map(accId => {
                      const acc = connectedAccountsRPA[accId][0];
                      const isClientNamePresent = connectedAccountsRPA[accId]?.some(brands => brands.client_name) ?? false;
                      return (
                        <div className={styles.accountItemRoot}>
                          <div className={styles.finalAccount}>
                            <div>
                              <h3>{acc.customer_name}</h3>
                              <p>{acc.customer_id}</p>
                              {isClientNamePresent ? <div className={styles.brandNames}>
                                {
                                  connectedAccountsRPA[accId].map(brands => {
                                    return brands.client_name ? (<p>{brands.client_name}</p>) : null;
                                  })
                                }
                              </div> : null}
                            </div>
                            {
                              acc.expired ?
                                (<div className={styles.ipAuth}>
                                  <div
                                    className={styles.Authenticate}
                                    onClick={() => {
                                      const user = getLocalUser();
                                      Integrations(
                                        ip.companyName,
                                        ip._id,
                                        user,
                                        ip,
                                        step,
                                        setStep,
                                        setIp,
                                        false
                                      );
                                    }}
                                  >
                                    <VscUnlock />
                                    <p>Reconnect</p>
                                  </div>
                                </div>) :
                                <MeritoButton type="destructive-ghost" onlyIcon={true} icon={<AiOutlineMinusCircle />} onClick={() => {
                                  setSelectedId(acc.id);
                                  setSelectedAccount(acc);
                                  setStep(6);
                                }} extraStyles={{ height: '2rem' }} />
                            }
                          </div>
                        </div>
                      )
                    })
                    :
                    connectedAccounts.map((acc) => {
                      return (
                        <div className={styles.accountItemRoot}>
                          <div className={styles.finalAccount}>
                            <div>
                              {acc.storeName ? (
                                <>
                                  <h3>{acc.storeName}</h3>
                                  {acc.customer_name ? (
                                    <p>{acc.customer_name}</p>
                                  ) : null}
                                </>
                              ) : acc.client_id || acc.client_name ? (
                                acc.client_name ? (
                                  <div>
                                    <h3>{acc.client_name}</h3>
                                    <p>{acc.client_id}</p>
                                  </div>
                                ) : (
                                  <div>
                                    <h3>{acc.client_id}</h3>
                                  </div>
                                )
                              ) : acc.customer_name ? (
                                <div>
                                  <h3>{acc.customer_name}</h3>
                                  <p>{acc.customer_id}</p>
                                </div>
                              ) : (
                                <h3>{acc.customer_id}</h3>
                              )}
                            </div>
                            {
                              acc.expired ?
                                (<div className={styles.ipAuth}>
                                  <div
                                    className={styles.Authenticate}
                                    onClick={() => {
                                      const user = getLocalUser();
                                      Integrations(
                                        ip.companyName,
                                        ip._id,
                                        user,
                                        ip,
                                        step,
                                        setStep,
                                        setIp,
                                        false
                                      );
                                    }}
                                  >
                                    <VscUnlock />
                                    <p>Reconnect</p>
                                  </div>
                                </div>) :
                                <MeritoButton type="destructive-ghost" onlyIcon={true} icon={<AiOutlineMinusCircle />} onClick={() => {
                                  setSelectedId(acc.id);
                                  setSelectedAccount(acc);
                                  setStep(6);
                                }} />
                              // <AiOutlineMinusCircle
                              //   onClick={() => {
                              //     setSelectedId(acc.id);
                              //     setSelectedAccount(acc);
                              //     setStep(6);
                              //   }}
                              // />
                            }
                          </div>
                          {/* {connectedAccounts?.length > 1 ? <hr className={styles.divider} /> : null} */}
                          {/* <hr className={styles.divider} />} */}
                        </div>
                      );
                    })
                }
              </div>
            </div> : null}
          {disconnectedAccounts?.length && showExpiredSplit ?
            <div className={styles.accountSection}>
              <div className={styles.accountHeader}>
                DISCONNECTED ACCOUNTS ({disconnectedAccounts?.length})
              </div>
              <div className={styles.acc}>
                {disconnectedAccounts.map((acc) => {
                  return (
                    <div className={styles.accountItemRoot}>
                      <div className={styles.finalAccount}>
                        <div>
                          {acc.storeName ? (
                            <>
                              <h3>{acc.storeName}</h3>
                              {acc.customer_name ? (
                                <p>{acc.customer_name}</p>
                              ) : null}
                            </>
                          ) : acc.client_id || acc.client_name ? (
                            acc.client_name ? (
                              <div>
                                <h3>{acc.client_name}</h3>
                                <p>{acc.client_id}</p>
                              </div>
                            ) : (
                              <div>
                                <h3>{acc.client_id}</h3>
                              </div>
                            )
                          ) : acc.customer_name ? (
                            <div>
                              <h3>{acc.customer_name}</h3>
                              <p>{acc.customer_id}</p>
                            </div>
                          ) : (
                            <h3>{acc.customer_id}</h3>
                          )}
                        </div>
                        <MeritoButton type="destructive-ghost" onlyIcon={true} icon={<DeleteIcon />} onClick={() => {
                          console.log('acc', acc);
                          setDeleteItem({ accessTokenId: acc.id, isConnected: acc.isConnected });
                          setShowDeleteConfirmation(true)
                        }} />
                        {/* <AiOutlineMinusCircle
                        onClick={() => {
                          setSelectedId(acc.id);
                          setSelectedAccount(acc);
                          setStep(6);
                        }}
                      /> */}
                      </div>
                      {/* {disconnectedAccounts?.length > 1 ? <hr className={styles.divider} /> : null} */}
                    </div>
                  );
                })}
              </div>
            </div> : null}
          {/* {isRPA && Object.values(disconnectedAccountsRPA)?.length ?
              <div className={styles.accountSection}>
                <div className={styles.accountHeader}>
                  DISCONNECTED ACCOUNTS ({Object.values(disconnectedAccountsRPA)?.length})
                </div>
                <div className={styles.acc}>
                  {
                    Object.keys(disconnectedAccountsRPA).map(accId => {
                      const acc = disconnectedAccountsRPA[accId][0]
                      return (
                        <div className={styles.accountItemRoot}>
                            <div className={styles.finalAccount}>
                              <div>
                                <h3>{acc.customer_name}</h3>
                                <p>{acc.customer_id}</p>
                                <div className={styles.brandNames}>
                                    {
                                      disconnectedAccountsRPA[accId].map(brands => {
                                        return (<p>{brands.client_name}</p>)
                                      })
                                    }
                                </div>
                              </div>
                              {
                                acc.expired ?
                                  (<div className={styles.ipAuth}>
                                    <div
                                      className={styles.Authenticate}
                                      onClick={() => {
                                        const user = getLocalUser();
                                        Integrations(
                                          ip.companyName,
                                          ip._id,
                                          user,
                                          ip,
                                          step,
                                          setStep,
                                          setIp,
                                          false
                                        );
                                      }}
                                    >
                                      <VscUnlock />
                                      <p>Reconnect</p>
                                    </div>
                                  </div>) :
                                  <MeritoButton type="destructive-ghost" onlyIcon={true} icon={<AiOutlineMinusCircle />} onClick={() => {
                                    setSelectedId(acc.id);
                                    setSelectedAccount(acc);
                                    setStep(6);
                                  }} extraStyles={{height: '2rem'}}/>
                              }
                            </div>
                          </div>
                      )
                    })
                  }
                </div>
              </div >
           : null} */}
        </div>
      ) : null}
      {step == 6 ? (
        <div className={styles.statusScreen}>
          <div className={`${styles.info} ${styles.error}`}>
            <AiFillInfoCircle />
          </div>
          <h1>Would you like to disconnect this {ip?.companyName} account?</h1>
          <div className={styles.disconnectWarning}>
            <BsExclamationTriangleFill />
            <div>
              <li>
                You will no longer be able to see data from{" "}
                {getName(selectedAccount)} for {ip?.companyName} in your Merito
                Workspaces.
              </li>
            </div>
          </div>
        </div>
      ) : null}
      {step == 7 ? (
        <div className={styles.statusScreen}>
          <div className={`${styles.info} ${styles.success}`}>
            <BsFillCheckCircleFill />
          </div>
          <h1>Your {ip?.companyName} account was disconnected successfully!</h1>
          <li>
            You will no longer be able to see data from{" "}
            {getName(selectedAccount)} for {ip?.companyName} in your Merito
            Workspaces.
          </li>
          <li>This process may take up to 3 minutes.</li>
        </div>
      ) : null}

      <ConfirmDialog
        modalStyles={{ maxWidth: '450px' }}
        showButton={false}
        visible={showDeleteConfirmation}
        toggle={() => {
          setShowDeleteConfirmation(!showDeleteConfirmation);
        }}
        showCloseBtn={false}
        size={"md"}
      >
        <div className={styles.confirmationContainer}>
          <div className={styles.topContainer}>
            <div className={styles.iconContainer}>
              <Exclamation />
            </div>
            <div className={styles.title}>
              Delete Account Data ?
            </div>

            <div className={styles.warningText}>
              This will delete all information <br />
              about this account from Merito.
              <br />
              <br />
              This may affect your credit eligibility.
            </div>
          </div>

          <div className={styles.bottomContainer}>
            <MeritoButton onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText="Cancel" />
            <MeritoButton loading={deleteBtnLoading} size="lg" onClick={() => {
              deleteAccount(deleteItem.accessTokenId, deleteItem.isConnected)
            }} isRounded={true} btnType="button" type="primary-1" btnText="Delete Account" />
          </div>
        </div>
      </ConfirmDialog>
    </>
  );
};

const ForwardedDisconnectComponent = forwardRef(DisconnectScreen);

export default ForwardedDisconnectComponent;